import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Layout, Col, Row, Typography, Divider } from "antd";
import { titleStyle, activeStyle, deActiveStyle, logoStyle } from "../StyleObj";
import PropTypes from 'prop-types';
import "antd/dist/antd.min.css";
import ThemeToggle from "./ThemeToggle";
import { useTheme } from "./ThemeContext";
import { Colors } from "./utils";
const { Header, Content } = Layout;
const { Title } = Typography;
/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
export const PageLayout = (props) => {
  PageLayout.propTypes = {
    role: PropTypes.any,
    children: PropTypes.any,
  };
  const unLoad = false;
  const navigate = useNavigate();
  const location = useLocation();
  const { theme} = useTheme();

  /**
   * Method to check the navigation
   * @param {*} path
   */
  const navigationCheck = async (path) => {
    if (location.pathname.includes("model")) {
      navigate(path, { replace: true });
    } else {
      const evt = new CustomEvent(location.pathname, {
        detail: {
          pathName: path,
        },
      });
      window.dispatchEvent(evt);
    }
  };
  /**
   * Map the children with props
   */
  const childrenWithProps = React.Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { unLoad });
    }
    return child;
  });

  return (
    <div>
      {props.role ? (
        <Layout className="layout layout_css">
          <Header className={`header_css-${theme}`}>
            <Row align="middle" justify="space-between" gutter={16}>
              <Col>
                <Row align="middle" justify="start" gutter={[16, 0]}>
                  <Col align="middle" >
                    <img
                      height={24}
                      src={theme===Colors.dark? "/menu.svg": "menu-Light.svg"}
                      alt="menu-logo"
                      style={logoStyle}
                    />
                  </Col>
                  <Col>
                    <img
                      className="rotate"
                      height={24}
                      src={theme===Colors.dark?"/accenture-logo.svg":"accenture-logo-light.svg"}
                      alt="acn-logo"
                    />
                  </Col>
                  <Col>
                    <Title style={titleStyle(theme)}>TWIN BUILDER</Title>
                  </Col>
                  <Divider className={`divider1-${theme}`} type="vertical" />
                  <Divider className={`divider2-${theme}`} type="vertical" />
                  <Col className="header_model">
                    <Button
                      type="text"
                      
                      className={`header_model-text-${theme}`}
                      style={
                        location.pathname.includes("model")
                        ? activeStyle(theme)
                        : deActiveStyle(theme)
                      }
                      onClick={() => navigationCheck("/model")}
                    >
                      Model
                    </Button>
                  </Col>
                  <Divider className={`divider1-${theme}`} type="vertical" />
                  <Divider className={`divider2-${theme}`} type="vertical" />
                  <Col>
                    <Button
                      type="text"
                      style={
                        location.pathname.includes("poi")
                        ? activeStyle(theme)
                        : deActiveStyle(theme)
                      }
                      onClick={() => navigationCheck("/poi")}
                    >
                      POI Editor
                    </Button>
                  </Col>
                  <Divider className={`divider1-${theme}`} type="vertical" />
                  <Divider className={`divider2-${theme}`} type="vertical" />
                  <Col>
                    <Button
                      type="text"
                      style={
                        location.pathname.includes("mapper")
                        ? activeStyle(theme)
                        : deActiveStyle(theme)
                      }
                      onClick={() => navigationCheck("/mapper")}
                    >
                      Mapper
                    </Button>
                  </Col>

                  <Divider className={`divider1-${theme}`} type="vertical" />
                  <Divider className={`divider2-${theme}`} type="vertical" />
                  <Col>
                    <Button
                      type="text"
                      style={
                        location.pathname.includes("plant")
                        ? activeStyle(theme)
                        : deActiveStyle(theme)
                      }
                      onClick={() => navigationCheck("/plant")}
                    >
                      Plant Layout
                    </Button>
                  </Col>
                </Row>
              </Col>

              <Col>
                <div>
                <span>
                    <ThemeToggle></ThemeToggle>
                  </span>
                  <span className="bellLeft">
                    <img
                      width={25}
                      src="/Notifications_grey.png"
                      alt="notification"
                      style={{ userSelect: 'none' }}
                    />
                  </span>
                  <span className="divAlignRight">
                    <img width={25} src="/User.png" alt="user" style={{ userSelect: 'none' }} />
                  </span>
                </div>
              </Col>
            </Row>
            <Row></Row>
          </Header>
          <Content>{childrenWithProps}</Content>
        </Layout>
      ) : (
        <Layout className="layout layout_css">
          <Content>{props.children}</Content>
        </Layout>
      )}
    </div>
  );
};
